import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfCartao, ModelOfCartaoLiberacao, ModelOfVehicleItem } from '../../database';
import api from '../../services/api';
import * as Yup from 'yup';

const initialValuesOfUnityCartao = {
    ID: '',
    ORGAO: '',
    DESCRICAO: '',
    IDENTIFICACAO: '',
    CURINGA: 1,
    STATUS: 0,
};

const initialValuesOfUnityCartaoLiberacao = {
    ID: '',
    FT_VEICULO: '',
    FT_CARTAO: '',
    DATAINICIO: '',
    DATAFIM: '',
    STATUS: 0
};

export const useListUnityCartaosController = () => {
    const [unityCartaosData, setUnityCartaosData] = useState<ModelOfCartao[]>([]);
    const [unityCartaosLiberacaoData, setUnityCartaosLiberacaoData] = useState<ModelOfCartaoLiberacao[]>([])
    const [selectedUnityCartao, setSelectedUnityCartao] = useState<ModelOfCartao>(initialValuesOfUnityCartao);
    const [selectedUnityCartaoLiberacao, setSelectedUnityCartaoLiberacao] = useState<ModelOfCartaoLiberacao>(initialValuesOfUnityCartaoLiberacao);
    const [loading, setLoading] = useState(false);
    const [loadingRows, setLoadingRows] = useState(false);
    const [loadingEdit, setLoadingEdit] = useState(false);
    const [rows, setRows] = useState(0);
    const { userAgencyId } = useAuth();
    const toast: any = useRef();
    const [editDialog, setEditDialog] = useState(false);
    const [liberacaoDialog, setLiberacaoDialog] = useState(false);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [deleteCartaoLiberacaoDialog, setDeleteCartaoLiberacaoDialog] = useState(false);
    const [vehicleList, setVehicleList] = useState<ModelOfVehicleItem[]>([]);


    const validationSchemaLiberacao = Yup.object().shape({
        FT_VEICULO: Yup.string().required('* Campo obrigatório'),
        DATAINICIO: Yup.string().required('* Campo obrigatório'),
        DATAFIM: Yup.string().required('* Campo obrigatório'),
    });

    const validationSchema = Yup.object().shape({
        DESCRICAO: Yup.string().required('* Campo obrigatório'),
        IDENTIFICACAO: Yup.string().required('* Campo obrigatório'),
    });



    const formik = useFormik<ModelOfCartao>({
        initialValues: {
            ORGAO: '',
            DESCRICAO: '',
            IDENTIFICACAO: '',
            CURINGA: 0,
            STATUS: 0,
        },
        onSubmit: async values => await editCartao(values),
        validationSchema: validationSchema,
    });

    const formikLiberacao = useFormik<ModelOfCartaoLiberacao>({
        initialValues: {
            FT_CARTAO: '',
            DATAINICIO: '',
            DATAFIM: '',
            STATUS: 0,
            FT_VEICULO: '',
        },
        onSubmit: async values => await saveCartaoLiberacao(values),
        validationSchema: validationSchemaLiberacao,
    });

    const saveCartaoLiberacao = async (cartaoLiberacao: ModelOfCartaoLiberacao) => {
        setLoading(true);
        api.post('cartaoliberacao', cartaoLiberacao)
            .then((response) => {
                setLoading(false);
                toast.current.show({ severity: 'success', summary: 'Cadastro realizado', detail: 'Operação realizada com sucesso!', life: 5000 });
                getCartaoLiberacaos();
            }).catch((err) => {
                console.log("response: ", err)
                setLoading(false);
                toast.current.show({ severity: 'error', summary: 'Cadastro não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
            });
        setLoading(false);
    }

    const getCartaos = async () => {
        api.get(`cartaos/${userAgencyId}`)
            .then(response => {
                const data = response.data;
                setUnityCartaosData(data);
                setLoading(false);
            })
            .catch((response: AxiosResponse) => {
                console.log('erro: ', response.statusText);
                setLoading(false);
            });
    };



    const getCartaoLiberacaos = () => {
        setLoading(true)
        api.get(`cartaoliberacao/${selectedUnityCartao?.ID}`)
            .then(response => {
                const data = response.data;
                setUnityCartaosLiberacaoData(data);
                setLoading(false);
            })
            .catch((response: AxiosResponse) => {
                console.log('erro: ', response.statusText);
                setLoading(false);
            });
        setLoading(false);
    };

    useEffect(() => {
        getCartaos();
    }, []);

    const editCartao = (cartao: ModelOfCartao) => {
        console.log("entrei aqui")
        setLoading(true);

        const editedCartao: ModelOfCartao = {
            ...cartao,
            ORGAO: userAgencyId,
        };
        console.log("vai gravar a auteracao: ", editCartao)
        api.put(`cartaos/${selectedUnityCartao?.ID}`, editedCartao)
            .then(() => {
                getCartaos();
                setEditDialog(false);
                setLoading(false);
                toast.current.show({
                    severity: 'success',
                    summary: 'Edição realizada',
                    detail: 'A cartão foi editada com sucesso!',
                    life: 5000,
                });
            })
            .catch(err => {
                getCartaos();
                setEditDialog(false);
                setLoading(false);
                toast.current.show({
                    severity: 'error',
                    summary: 'Edição não realizado',
                    detail: 'Falha ao realizar operação!',
                    life: 5000,
                });
            });
    };

    const removeCartao = (cartao: ModelOfCartao) => {
        setLoading(true);
        api.delete(`cartaos/${cartao.ID}`)
            .then(() => {
                getCartaos();
                setDeleteDialog(false);
                setLoading(false);
                toast.current.show({
                    severity: 'success',
                    summary: 'Remoção realizada',
                    detail: 'O Cartão foi removida com sucesso!',
                    life: 5000,
                });
            })
            .catch(err => {
                getCartaos();
                setDeleteDialog(false);
                setLoading(false);
                toast.current.show({
                    severity: 'error',
                    summary: 'Remoção não realizado',
                    detail: 'Falha ao realizar operação!',
                    life: 5000,
                });
            });
    };

    const openEditDialog = (cartao: ModelOfCartao) => {
        setEditDialog(true);
        setSelectedUnityCartao(cartao);
    };

    const openLiberacaoDialog = (cartao: ModelOfCartao) => {
        setLiberacaoDialog(true);
        formikLiberacao.setFieldValue("FT_CARTAO", cartao.ID)
        getVehicleList(cartao);
        setSelectedUnityCartao(cartao);
    };

    const openDeleteDialog = (cartao: ModelOfCartao) => {
        setDeleteDialog(true);
        setSelectedUnityCartao(cartao);
    };

    const closeDeleteDialog = () => {
        setDeleteDialog(false);
    };

    const closeEditDialog = () => {
        setEditDialog(false);
    };

    const closeLiberacaoDialog = () => {
        console.log("fechou a tela de Liberação")
        setLiberacaoDialog(false);
    };

    const fazNadaLiberacaoDialog = () => {
        console.log("fechou a tela de Liberação")
        setLiberacaoDialog(false);
    };

    const vehicles = vehicleList.map(vehicle => {
        return { label: vehicle.PLACA + " | " + vehicle.DESCRICAO, value: vehicle.ID };
    });

    const getVehicleList = async (cartao: ModelOfCartao) => {
        console.log("lista veiculos ...:", cartao.ID)

        const response = await api.post(`get-vehicles`, { ORGAO: userAgencyId }).then((response) => {
            setVehicleList(response.data);
            setLoading(false);
        })
            .catch((response: AxiosResponse) => {
                console.log('erro: ', response.status);
                setLoading(false);
            });
    };

    const editCartaoLiberacao = async (CartaoLiberacao: ModelOfCartaoLiberacao) => {
		/*setLoading(true);

		const editedCreditorTipoCombustivel: ModelOfCreditorTipoCombustivel = {
			...CreditorTipoCombustivel,

		};
		editedCreditorTipoCombustivel.CREDOR = selectedCreditor.ID

		api.put(`creditorstipocombustivel/`, editedCreditorTipoCombustivel)
			.then(() => {
				getCreditorTipoCombustivels();
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'O credor foi editada com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getCreditorTipoCombustivels();
				setLoading(false);;
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação! ' + err,
					life: 5000,
				});
			});
		setLoading(false); */
	};

    const removeCartaoLiberacao = async (CartaoLiberacao: ModelOfCartaoLiberacao) => {
		setLoading(true);
        console.log("CartaoLiberacao.ID --> ",CartaoLiberacao.ID);
		api.delete(`cartaoliberacao/${CartaoLiberacao.ID}`)
			.then(response => {
				const newList = unityCartaosLiberacaoData.filter(cartaoliberacao => cartaoliberacao.ID !== response.data.ID);
				setUnityCartaosLiberacaoData(newList);
				setDeleteCartaoLiberacaoDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'O cartão foi removido com sucesso!',
					life: 5000,
				});
			})
			.catch(() => {
				getCartaoLiberacaos();
				setDeleteCartaoLiberacaoDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

    const openDeleteCartaoLiberacaoDialog = (CartaoLiberacao: ModelOfCartaoLiberacao) => {
		setDeleteCartaoLiberacaoDialog(true);
		setSelectedUnityCartaoLiberacao(CartaoLiberacao);
	};
    const closeDeleteCartaoLiberacaoDialog = () => {
		setDeleteCartaoLiberacaoDialog(false);
	};

    return {
        getCartaoListController: {
            formik,
            formikLiberacao,
            unityCartaosData,
            unityCartaosLiberacaoData,
            selectedUnityCartao,
            loading,
            deleteDialog,
            editDialog,
            liberacaoDialog,
            toast,
            vehicles,
            getCartaoLiberacaos,
            deleteCartaoLiberacaoDialog,
            
        },
        handleCartaoListController: {
            selectedUnityCartaoLiberacao,
            openDeleteCartaoLiberacaoDialog,
            editCartaoLiberacao,
            removeCartao,
            editCartao,
            openDeleteDialog,
            closeDeleteDialog,
            openEditDialog,
            openLiberacaoDialog,
            closeEditDialog,
            closeLiberacaoDialog,
            fazNadaLiberacaoDialog,
            closeDeleteCartaoLiberacaoDialog,
            removeCartaoLiberacao,
        },
    };
}